<template>
  <div class="page-py">
    <div class="container container-px">
      <section class="about">
        <div class="about-info">
          <!--        <div class="about__info-subtitle">-->
          <!--          {{ $t('DreamFlat') }}-->
          <!--        </div>-->
          <h1 class="about-info__title">
            {{ $t('dfFor') }}
            <span>{{ $t('furnitureCompanies') }}</span>
          </h1>
          <p class="about-info__desc">
            {{ $t('forMakersDesc') }}
          </p>
          <DownloadLauncherButton
            icon=""
            :add-version-to-label="false"
          />
        </div>
        <div class="about-image">
          <img
            :src="`${staticUrl}/images/solution-for-makers.webp`"
            alt=""
            class="about-image__img"
          />
        </div>
      </section>
      <section class="df-tools">
        <div class="df-tools__title">
          {{ $t('dfTools') }}
        </div>
        <div class="df-tools-box">
          <div class="df-tools-box-item df-tools-box-item_reverce">
            <div class="df-tools-box-item-video">
              <video no-controls autoplay loop playsinline muted>
                <source
                  :src="`${staticUrl}/video/for-designers-1.mp4`"
                  type="video/mp4"
                />
              </video>
            </div>
            <div class="df-tools-box-item-info">
              <p class="df-tools-box-item-info__title">
                {{ $t('builtinL') }}
              </p>
              <p class="df-tools-box-item-info__text">
                {{ $t('forDesModelInfo') }}
              </p>
            </div>
          </div>
          <div class="df-tools-box-item">
            <div class="df-tools-box-item-video">
              <video no-controls autoplay loop playsinline muted>
                <source
                  :src="`${staticUrl}/video/for-designers-3.mp4`"
                  type="video/mp4"
                />
              </video>
            </div>
            <div class="df-tools-box-item-info">
              <p class="df-tools-box-item-info__title">
                {{ $t('upldUrModelMaterial') }}
              </p>
              <p class="df-tools-box-item-info__text">
                {{ $t('upldUrModelMateriaDesSt') }}
              </p>
            </div>
          </div>
          <div class="df-tools-box-item df-tools-box-item_reverce">
            <div class="df-tools-box-item-video">
              <video no-controls autoplay loop playsinline muted>
                <source
                  :src="`${staticUrl}/video/for-makers-3.mp4`"
                  type="video/mp4"
                />
              </video>
            </div>
            <div class="df-tools-box-item-info">
              <p class="df-tools-box-item-info__title">
                {{ $t('editableModels') }}
              </p>
              <p class="df-tools-box-item-info__text">
                {{ $t('editableModelsWardrobe') }}
              </p>
            </div>
          </div>
          <div class="df-tools-box-item">
            <div class="df-tools-box-item-video">
              <video no-controls autoplay loop playsinline muted>
                <source
                  :src="`${staticUrl}/video/for-makers-4.mp4`"
                  type="video/mp4"
                />
              </video>
            </div>
            <div class="df-tools-box-item-info">
              <p class="df-tools-box-item-info__title">
                {{ $t('finishingWord') }}
              </p>
              <p class="df-tools-box-item-info__text">
                {{ $t('dontWorry') }}
              </p>
            </div>
          </div>
          <div class="df-tools-box-item df-tools-box-item_reverce">
            <div class="df-tools-box-item-video">
              <video no-controls autoplay loop playsinline muted>
                <source
                  :src="`${staticUrl}/video/for-designers-4.mp4`"
                  type="video/mp4"
                />
              </video>
            </div>
            <div class="df-tools-box-item-info">
              <p class="df-tools-box-item-info__title">
                {{ $t('bestGraphQuality') }}
              </p>
              <p class="df-tools-box-item-info__text">
                {{ $t('bestGraphQualityDesc') }}
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="features-box">
        <div class="features-box-info">
          <div class="features-box-info__title">
            {{ $t('virtualShowroom') }}
          </div>
          <div class="features-box-info__sub-title">
            {{ $t('createShowroom') }}
          </div>
          <div class="features-box-info-container">
            <div class="features-box-info-elements">
              <div class="element">
                <div class="element__title">
                  {{ $t('availability') }}
                </div>
                <div class="element__sub-title">
                  {{ $t('showroomForPotentialClient') }}
                </div>
              </div>
              <div class="element">
                <div class="element__title">
                  {{ $t('convenience') }}
                </div>
                <div class="element__sub-title">
                  {{ $t('convenienceDesc') }}
                </div>
              </div>
              <div class="element">
                <div class="element__title">
                  {{ $t('highDetail') }}
                </div>
                <div class="element__sub-title">
                  {{ $t('highDetailDesc') }}
                </div>
              </div>
              <div class="element">
                <div class="element__title">
                  {{ $t('savingTime') }}
                </div>
                <div class="element__sub-title">
                  {{ $t('savingTimeDesc') }}
                </div>
              </div>
            </div>
            <div class="features-box-info-video">
              <img
                :src="`${staticUrl}/images/solution-virtual-showroom.webp`"
                alt=""
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
      <section class="switcher-box">
        <div class="switcher-box__title">
          {{ $t('projDemonstrOpt') }}
        </div>
        <div class="switcher">
          <div class="switcher-chose-box">
            <div
              class="switcher-chose-box__element"
              :class="{
                'switcher-chose-box__element_active':
                  featuresCounter === 1,
              }"
              @click="featuresCounter = 1"
            >
              <div class="el-number">1</div>
              <div class="el-info">
                <div class="el-title">
                  {{ $t('renders') }}
                </div>
                <!--              <div class="el-text">{{ $t('Static renderers are an integral part of the visualization of any project. DreamFlat allows you to shoot photorealistic renderings in just a few seconds!') }}</div>-->
              </div>
            </div>
            <div
              class="switcher-chose-box__element"
              :class="{
                'switcher-chose-box__element_active':
                  featuresCounter === 2,
              }"
              @click="featuresCounter = 2"
            >
              <div class="el-number">2</div>
              <div class="el-info">
                <div class="el-title">
                  {{ $t('videoFlythroughs') }}
                </div>
                <!--              <div class="el-text">{{ $t('Video clips complement the renderings, presenting the apartment on any device from several angles. All you need to create a video flight through the interior is to adjust the viewing angle and speed of the camera.') }}</div>-->
              </div>
            </div>
            <div
              class="switcher-chose-box__element"
              :class="{
                'switcher-chose-box__element_active':
                  featuresCounter === 3,
              }"
              @click="featuresCounter = 3"
            >
              <div class="el-number">3</div>
              <div class="el-info">
                <div class="el-title">
                  {{ $t('tours3DWeb') }}
                </div>
                <!--              <div class="el-text">{{ $t('3D-tours are a tool that makes it possible to virtually study the layout of an apartment and present the interior from all sides.') }}</div>-->
              </div>
            </div>
            <div
              class="switcher-chose-box__element"
              :class="{
                'switcher-chose-box__element_active':
                  featuresCounter === 4,
              }"
              @click="featuresCounter = 4"
            >
              <div class="el-number">4</div>
              <div class="el-info">
                <div class="el-title">
                  {{ $t('interactiveTours') }}
                </div>
                <!--              <div class="el-text">{{ $t('You can move around the apartment right in front of the client — using a keyboard or a computer mouse.') }}</div>-->
              </div>
            </div>
            <div
              class="switcher-chose-box__element"
              :class="{
                'switcher-chose-box__element_active':
                  featuresCounter === 5,
              }"
              @click="featuresCounter = 5"
            >
              <div class="el-number">5</div>
              <div class="el-info">
                <div class="el-title">
                  {{ $t('vr') }}
                </div>
                <!--              <div class="el-text">{{ $t('The DreamFlat VR mode allows you to move into an apartment and, as if live, feel its dimensions, the size of windows and the height of ceilings. And high quality graphics will give you the opportunity to evaluate the details of interior design.') }}</div>-->
              </div>
            </div>
          </div>

          <div class="switcher-info-box">
            <transition name="switcher-animation" mode="out-in">
              <div
                v-if="featuresCounter === 1"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">
                    {{ $t('renders') }}
                  </div>
                  <div class="info-container__text">
                    {{ $t('rendersDesc') }}
                  </div>
                </div>
                <div class="video-container">
                  <div class="video-container__image">
                    <img
                      :src="`${staticUrl}/images/solution-renders.webp`"
                      alt=""
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
              <div
                v-else-if="featuresCounter === 2"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">
                    {{ $t('videoFlythroughs') }}
                  </div>
                  <div class="info-container__text">
                    {{ $t('videoFlyDesc') }}
                  </div>
                </div>
                <div class="video-container">
                  <div class="video-container__video">
                    <video
                      no-controls
                      autoplay
                      loop
                      playsinline
                      muted
                    >
                      <source
                        :src="`${staticUrl}/video/video-fly.mp4`"
                        type="video/mp4"
                      />
                    </video>
                  </div>
                </div>
              </div>
              <div
                v-else-if="featuresCounter === 3"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">
                    {{ $t('tours3DWeb') }}
                  </div>
                  <div class="info-container__text">
                    {{ $t('tour3dDesc') }}
                  </div>
                  <a
                    href="https://dreamflat.design/tours/Tour_from_09.03.2023_17-46-58-460/index.htm?n=2"
                    target="_blank"
                  >
                    <ui-button
                      color="primary"
                      class="button about-info-btn"
                      no-caps
                      :label="$t('open')"
                    />
                  </a>
                </div>
                <div class="video-container">
                  <div class="video-container__video" />
                </div>
              </div>
              <div
                v-else-if="featuresCounter === 4"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">
                    {{ $t('interactiveTours') }}
                  </div>
                  <div class="info-container__text">
                    {{ $t('interactiveToursDesc') }}
                  </div>
                </div>
                <div class="video-container">
                  <div class="video-container">
                    <div class="video-container__video">
                      <video
                        no-controls
                        autoplay
                        loop
                        playsinline
                        muted
                      >
                        <source
                          :src="`${staticUrl}/video/interactive-tour.mp4`"
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else-if="featuresCounter === 5"
                class="switcher-info-box-child"
              >
                <div class="info-container">
                  <div class="info-container__title">
                    {{ $t('vr') }}
                  </div>
                  <div class="info-container__text">
                    {{ $t('vrDesc') }}
                  </div>
                </div>
                <div class="video-container">
                  <div class="video-container__image">
                    <img
                      :src="`${staticUrl}/images/solution-vr1.webp`"
                      alt=""
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="mobile-switcher">
          <div class="switcher-info-box">
            <swiper
              class="mySwiper"
              :pagination="true"
              :modules="modules"
            >
              <swiper-slide>
                <div class="switcher-info-box-child">
                  <div class="info-container">
                    <div class="info-container__title">
                      {{ $t('renders') }}
                    </div>
                    <div class="info-container__text">
                      {{ $t('rendersDesc') }}
                    </div>
                  </div>
                  <div class="video-container">
                    <div class="video-container__image">
                      <img
                        :src="`${staticUrl}/images/solution-renders.webp`"
                        alt=""
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="switcher-info-box-child">
                  <div class="info-container">
                    <div class="info-container__title">
                      {{ $t('videoFlythroughs') }}
                    </div>
                    <div class="info-container__text">
                      {{ $t('videoFlyDesc') }}
                    </div>
                  </div>
                  <div class="video-container">
                    <div class="video-container__video">
                      <video
                        no-controls
                        autoplay
                        loop
                        playsinline
                        muted
                      >
                        <source
                          :src="`${staticUrl}/video/video-fly.mp4`"
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="switcher-info-box-child">
                  <div class="info-container">
                    <div class="info-container__title">
                      {{ $t('tours3DWeb') }}
                    </div>
                    <div class="info-container__text">
                      {{ $t('tour3dDesc') }}
                    </div>
                    <a
                      href="https://dreamflat.design/tours/Tour_from_09.03.2023_17-46-58-460/index.htm?n=2"
                      target="_blank"
                    >
                      <ui-button
                        color="primary"
                        class="button about-info-btn"
                        no-caps
                        :label="$t('open')"
                      />
                    </a>
                  </div>
                  <div class="video-container">
                    <div class="video-container__video" />
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="switcher-info-box-child">
                  <div class="info-container">
                    <div class="info-container__title">
                      {{ $t('interactiveTours') }}
                    </div>
                    <div class="info-container__text">
                      {{ $t('interactiveToursDesc') }}
                    </div>
                  </div>
                  <div class="video-container">
                    <div class="video-container">
                      <div class="video-container__video">
                        <video
                          no-controls
                          autoplay
                          loop
                          playsinline
                          muted
                        >
                          <source
                            :src="`${staticUrl}/video/interactive-tour.mp4`"
                            type="video/mp4"
                          />
                        </video>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="switcher-info-box-child">
                  <div class="info-container">
                    <div class="info-container__title">
                      {{ $t('vr') }}
                    </div>
                    <div class="info-container__text">
                      {{ $t('vrDesc') }}
                    </div>
                  </div>
                  <div class="video-container">
                    <div class="video-container__image">
                      <img
                        :src="`${staticUrl}/images/solution-vr1.webp`"
                        alt=""
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </section>
      <section class="examples-box">
        <div class="examples-box__title">
          {{ $t('examplesWorkRes') }}
        </div>
        <div class="examples-box-elements">
          <div
            class="examples-box-elements__el examples-box-elements__el-img1"
            :class="{
              'examples-box-elements__el_active':
                examplesCounter === 1,
            }"
            @mouseover="examplesCounter = 1"
          >
            <div class="examples-info">
              <div class="examples-info__title">
                {{ $t('dwfi') }}
              </div>
              <div class="examples-info__text">
                {{ $t('dwfiHotelRoom') }}
              </div>
              <div class="examples-info__link">
                <ui-link to="/gallery">
                  {{ $t('moreDetailed') }}
                </ui-link>
              </div>
            </div>
          </div>
          <div
            class="examples-box-elements__el examples-box-elements__el-img2"
            :class="{
              'examples-box-elements__el_active':
                examplesCounter === 2,
            }"
            @mouseover="examplesCounter = 2"
          >
            <div class="examples-info examples-info_custom-top">
              <div class="examples-info__title">
                {{ $t('stockholm') }}
              </div>
              <div class="examples-info__text">
                {{ $t('futuristicOpenSpace') }}
              </div>
              <div class="examples-info__link">
                <ui-link to="/gallery">
                  {{ $t('moreDetailed') }}
                </ui-link>
              </div>
            </div>
          </div>
          <div
            class="examples-box-elements__el examples-box-elements__el-img3"
            :class="{
              'examples-box-elements__el_active':
                examplesCounter === 3,
            }"
            @mouseover="examplesCounter = 3"
          >
            <div class="examples-info">
              <div class="examples-info__title">
                {{ $t('minotti') }}
              </div>
              <div class="examples-info__text">
                {{ $t('minottiShowroom') }}
              </div>
              <div class="examples-info__link">
                <ui-link to="/gallery">
                  {{ $t('moreDetailed') }}
                </ui-link>
              </div>
            </div>
          </div>
          <div
            class="examples-box-elements__el examples-box-elements__el-img4"
            :class="{
              'examples-box-elements__el_active':
                examplesCounter === 4,
            }"
            @mouseover="examplesCounter = 4"
          >
            <div class="examples-info examples-info_custom-top">
              <div class="examples-info__title">
                {{ $t('ogogo') }}
              </div>
              <div class="examples-info__text">
                {{ $t('forestFairytale') }}
              </div>
              <div class="examples-info__link">
                <ui-link to="/gallery">
                  {{ $t('moreDetailed') }}
                </ui-link>
              </div>
            </div>
          </div>
        </div>
        <div class="mobile-examples-box-elements">
          <swiper
            class="mySwiper"
            :pagination="true"
            :modules="modules"
          >
            <swiper-slide>
              <div
                class="examples-box-elements__el examples-box-elements__el-img1 examples-box-elements__el_active"
              >
                <div class="examples-info">
                  <div class="examples-info__title">
                    {{ $t('dwfi') }}
                  </div>
                  <div class="examples-info__text">
                    {{ $t('dwfiHotelRoom') }}
                  </div>
                  <div class="examples-info__link">
                    <!--              <router-link to="/gallery">{{ $t('More detailed') }}</router-link>-->
                    <router-link :to="'gallery' + '?ref=' + 1">
                      {{ $t('moreDetailed') }}
                    </router-link>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div
                class="examples-box-elements__el examples-box-elements__el-img2 examples-box-elements__el_active"
              >
                <div class="examples-info examples-info_custom-top">
                  <div class="examples-info__title">
                    {{ $t('stockholm') }}
                  </div>
                  <div class="examples-info__text">
                    {{ $t('futuristicOpenSpace') }}
                  </div>
                  <div class="examples-info__link">
                    <!--              <router-link to="/gallery">{{ $t('More detailed') }}</router-link>-->
                    <router-link :to="'gallery' + '?ref=' + 2">
                      {{ $t('moreDetailed') }}
                    </router-link>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div
                class="examples-box-elements__el examples-box-elements__el-img3 examples-box-elements__el_active"
              >
                <div class="examples-info">
                  <div class="examples-info__title">
                    {{ $t('minotti') }}
                  </div>
                  <div class="examples-info__text">
                    {{ $t('minottiShowroom') }}
                  </div>
                  <div class="examples-info__link">
                    <!--              <router-link to="/gallery">{{ $t('More detailed') }}</router-link>-->
                    <router-link :to="'gallery' + '?ref=' + 3">
                      {{ $t('moreDetailed') }}
                    </router-link>
                  </div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div
                class="examples-box-elements__el examples-box-elements__el-img4 examples-box-elements__el_active"
              >
                <div class="examples-info examples-info_custom-top">
                  <div class="examples-info__title">
                    {{ $t('ogogo') }}
                  </div>
                  <div class="examples-info__text">
                    {{ $t('forestFairytale') }}
                  </div>
                  <div class="examples-info__link">
                    <!--              <router-link to="/gallery">{{ $t('More detailed') }}</router-link>-->
                    <router-link :to="'gallery' + '?ref=' + 4">
                      {{ $t('moreDetailed') }}
                    </router-link>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </section>
    </div>
    <section class="end-block">
      <div class="end-block-info">
        <div
          class="end-block-info__title mobile-end-block-info__title"
        >
          {{ $t('growYourBusiness') }}
        </div>
        <div class="end-block-info__button">
          <DownloadLauncherButton
            icon=""
            :add-version-to-label="false"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {ref} from 'vue';
import {Swiper, SwiperSlide} from 'swiper/vue';
import 'swiper/css';
import {Pagination} from 'swiper';
import 'swiper/css/pagination';
import {useI18n} from 'vue-i18n';
import DownloadLauncherButton from '~/components/DownloadLauncherButton.vue';
import {useHead, useRuntimeConfig} from '#imports';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;

const {t} = useI18n();

useHead({
  title: `${t('dfFor')} ${t('furnitureCompanies')}`,
  meta: [
    {
      name: 'description',
      content: `${t('furnitureMetaDesc')}`,
    },
  ],
});
useSeoMeta({
  ogTitle: `${t('DreamFlat for ')}${t('furniture companies')}`,
  description: `${t('furnitureMetaDesc')}`,
  ogDescription: `${t('furnitureMetaDesc')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
});

const featuresCounter = ref(1);
const examplesCounter = ref(1);
const modules = [Pagination];
</script>

<style scoped lang="scss">
.switcher-animation-enter-active,
.switcher-animation-leave-active {
  transition: opacity 0.1s ease-in-out;
}

.switcher-animation-enter-from,
.switcher-animation-leave-to {
  opacity: 0;
}

.examples-box-animation-enter-active,
.examples-box-animation-leave-active {
  transition: opacity 0.1s ease-in-out;
}

.examples-box-animation-enter-from,
.examples-box-animation-leave-to {
  opacity: 0;
}

.container {
  max-width: 1128px;
  // max-width: 1024px;
  margin: 0 auto;
}

.about {
  display: flex;
  gap: 24px;
  align-items: center;
  margin-top: 96px;
  @media (max-width: 1023px) {
    margin-top: 0;
  }

  &-image,
  &-info {
    flex: 1;
  }

  &-info {
    width: 500px;

    &__subtitle {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0.02em;
      color: #839aaf;
    }

    &__title {
      font-weight: 700;
      font-size: 36px;
      line-height: 120%;
      letter-spacing: 0.03em;
      color: #3d424a;

      span {
        color: $primary;
      }
    }

    &__button {
      font-weight: 600;
      font-size: 14px;
      line-height: 19px;
    }

    &__desc {
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      letter-spacing: 0.03em;
      color: #64686e;
      margin-top: 24px;
      margin-bottom: 53px;
    }

    &__btn {
      margin-top: 24px;
    }
  }

  &-image {
    width: 500px;

    &__img {
      width: 100%;
      object-fit: contain;
      //@media (max-width: 1023px) {
      //  display: none;
      //}
    }
  }
}

.df-tools {
  //margin-top: 256px;
  //margin-top: 232px;
  margin-top: 208px;

  &__title {
    font-weight: 700;
    font-size: 36px;
    color: #3d424a;
    margin-bottom: 48px;
  }

  &-box {
    &-item {
      width: 100%;
      display: flex;
      gap: 24px;
      margin-bottom: 96px;

      &-video {
        width: 552px;

        video {
          width: 100%;
          border-radius: 16px;
        }
      }

      &-info {
        width: 552px;
        align-self: center;
        text-align: var(--var-text-align-left);

        &__title {
          font-weight: 700;
          font-size: 24px;
          line-height: 32px;
          letter-spacing: 0.03em;
          color: $primary;
          margin-bottom: 16px;
        }

        &__text {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          display: flex;
          align-items: center;
          letter-spacing: 0.02em;
          color: #64686e;
        }
      }
    }

    &-item_reverce {
      flex-direction: row-reverse;
    }
  }
}

.features-box {
  display: flex;
  gap: 24px;
  align-items: center;
  flex-direction: row-reverse;
  //.features-box-image{
  //  width: 500px;
  //  .features-box-image__img{
  //    width: 100%;
  //  }
  //}
  .features-box-info {
    //width: 500px;
    width: 100%;
    //margin: 255px auto;
    //margin: 232px auto;
    margin: 208px auto;

    .features-box-info__title {
      font-weight: 700;
      font-size: 36px;
      color: #3d424a;
      margin-bottom: 24px;
    }

    .features-box-info__sub-title {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.02em;
      color: #3d424a;
      margin-bottom: 48px;
    }

    .features-box-info-container {
      display: flex;
      gap: 24px;

      .features-box-info-elements {
        width: 500px;
        display: flex;
        flex-wrap: wrap;
        gap: 32px 24px;

        .element {
          width: 238px;

          .element__image {
            width: 48px;
          }

          .element__title {
            font-weight: 700;
            font-size: 18px;
            //margin: 16px 0 8px 0;
            margin-bottom: 8px;
            color: $primary;
          }

          .element__sub-title {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #64686e;
          }
        }
      }

      .features-box-info-video {
        width: 500px;

        video {
          width: 100%;
          border-radius: 16px;
        }

        img {
          width: 100%;
          border-radius: 16px;
        }
      }
    }
  }
}

.switcher-box {
  //margin-top: 255px;
  //margin-top: 232px;
  margin-top: 208px;

  &__title {
    font-weight: 700;
    font-size: 36px;
    line-height: 120%;
    color: #3d424a;
    margin-bottom: 48px;

    span {
      color: $primary;
    }
  }

  .switcher {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;

    &-chose-box {
      width: 50%;
      cursor: pointer;

      &__element {
        width: 110%;
        border-radius: 16px;
        background: #ffffff;
        padding: 24px;
        display: flex;
        gap: 16px;
        transition: background 0.3s ease-in-out;

        .el-number {
          width: 48px;
          height: 48px;
          border: 1.5px solid $primary;
          border-radius: 32px;

          background: #ffffff;

          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;

          color: $primary;

          font-weight: 700;
          font-size: 24px;
          line-height: 32px;
        }

        .el-info {
          align-self: center;

          .el-title {
            font-weight: 700;
            font-size: 18px;
            line-height: 24px;
            color: #3d424a;
          }

          .el-text {
            font-weight: 400;
            font-size: 16px;
            line-height: 140%;
            color: #839aaf;
          }
        }
      }

      .switcher-chose-box__element_active {
        background: #f6f8fd;

        .el-number {
          color: var(--var-white-100);
          background: $primary;
        }
      }
    }

    &-info-box {
      width: 50%;
      background: #f6f8fd;
      border-radius: 16px;
      cursor: default;

      &-child {
        width: 100%;
        height: 100%;
        padding: 24px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .info-container {
          margin-bottom: 32px;

          &__title {
            font-weight: 700;
            font-size: 24px;
            line-height: 32px;
            color: #3d424a;
            margin-bottom: 8px;
          }

          &__text {
            font-weight: 400;
            font-size: 16px;
            line-height: 140%;
            color: #64686e;
          }

          a {
            display: block;
            margin-top: 24px;
          }
        }

        .video-container {
          &__image {
            width: 100%;

            img {
              width: 100%;
              border-radius: 8px;
            }
          }

          &__video {
            width: 100%;

            video {
              width: 100%;
              border-radius: 8px;
            }
          }
        }
      }
    }
  }

  .mobile-switcher {
    display: none;
  }
}

.examples-box {
  //margin: 255px auto;
  //margin: 232px auto;
  margin: 208px auto;

  &__title {
    font-weight: 700;
    font-size: 36px;
    line-height: 120%;
    color: #3d424a;
    margin-bottom: 48px;

    span {
      color: $primary;
    }
  }

  .examples-box-elements {
    width: 100%;
    display: flex;
    //gap: 24px;
    justify-content: space-between;

    &__el {
      width: 183px;
      height: 394px;
      padding: 24px;
      border-radius: 16px;
      cursor: pointer;
      transition: width 0.1s ease-out;

      .examples-info {
        position: relative;
        top: 86%;

        &__title {
          font-weight: 700;
          font-size: 18px;
          line-height: 24px;
          margin-bottom: 8px;
          color: #ffffff;
        }

        &__text {
          display: none;
        }

        &__link {
          font-weight: 600;
          font-size: 14px;
          line-height: 19px;
          color: #ffffff;
          text-decoration: underline;
          margin-top: 16.5px;
          display: none;
        }
      }
    }

    &__el-img1 {
      background: linear-gradient(
          180deg,
          rgba(6, 44, 73, 0.4) 39.23%,
          rgba(6, 44, 73, 0.95) 100%
        ),
        url($static-url + '/images/solution-renders.webp');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &__el-img2 {
      background: linear-gradient(
          180deg,
          rgba(6, 44, 73, 0.4) 39.23%,
          rgba(6, 44, 73, 0.95) 100%
        ),
        url($static-url + '/images/Stockholm-renders-1.webp');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &__el-img3 {
      background: linear-gradient(
          180deg,
          rgba(6, 44, 73, 0.4) 39.23%,
          rgba(6, 44, 73, 0.95) 100%
        ),
        url($static-url + '/images/Minotty-renders-1.webp');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &__el-img4 {
      background: linear-gradient(
          180deg,
          rgba(6, 44, 73, 0.4) 39.23%,
          rgba(6, 44, 73, 0.95) 100%
        ),
        url($static-url + '/images/Forest-renders-1.webp');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }

    &__el_active {
      //&__el:hover {
      width: 394px;
      transition: all 0.1s ease-out;

      .examples-info {
        //position: relative;
        position: inherit;
        //top: 46%;
        &__text {
          display: block;
          font-weight: 400;
          font-size: 16px;
          line-height: 140%;
          color: #ffffff;
        }

        &__link {
          display: block;
        }
      }

      .examples-info_custom-top {
        //top: 40%;
      }
    }
  }

  .mobile-examples-box-elements {
    display: none;
  }
}

.end-block {
  background: no-repeat
    url($static-url + '/images/solution-back.webp') center;
  background-size: cover;
  padding: 167px 0;
  margin-bottom: -60px;

  .end-block-info {
    width: 1024px;
    margin: 0 auto;

    &__title {
      width: 690px;
      font-weight: 700;
      font-size: 36px;
      line-height: 120%;
      color: var(--var-white-100);
      margin-bottom: 40px;
    }

    &__button {
    }
  }
}

@media (max-width: 1023px) {
  .examples-box-elements {
    &__el {
      width: 20% !important;

      .examples-info__text {
        font-size: 14px !important;
      }
    }

    &__el_active {
      width: 35% !important;
    }
  }
  .end-block-info {
    width: 90% !important;
    margin: 0 auto;
  }
}

@media (max-width: 750px) {
  .container {
    .about {
      flex-wrap: wrap;
      gap: 40px;

      .about-info {
        width: 100%;
        flex: auto;

        &__title {
          font-size: 24px;
          line-height: 32px;
        }

        &__desc {
          font-size: 15px;
        }

        &__button {
          display: none;
        }
      }

      .about-image {
        width: 100%;
      }
    }

    .df-tools {
      margin-top: 128px;

      &__title {
        font-size: 24px;
        margin-bottom: 40px;
      }

      &-box {
        &-item {
          flex-wrap: wrap;
          flex-direction: column-reverse;
          gap: 16px;
          margin-bottom: 64px;

          &-video {
            width: 100%;
          }

          &-info {
            width: 100%;

            &__title {
              font-size: 18px;
              line-height: 24px;
              margin-bottom: 8px;
            }

            &__text {
              font-size: 15px;
              line-height: 140%;
              margin: 0;
            }
          }
        }

        &-item_reverce {
          flex-direction: column-reverse;
        }
      }
    }

    .features-box {
      .features-box-info {
        margin: 64px auto 0 auto;
        &__title {
          font-size: 24px;
          line-height: 32px;
          margin-bottom: 8px;
        }
        &__sub-title {
          width: 100%;
          font-size: 15px;
          line-height: 140%;
          margin-bottom: 40px;
        }
        &-container {
          flex-wrap: wrap;
          gap: 16px;
          .features-box-info-elements {
            width: 100%;
            .element {
              width: 100%;
              .element__title {
                font-size: 16px;
                line-height: 21px;
              }
              .element__sub-title {
                font-size: 15px;
                line-height: 140%;
              }
            }
          }
        }
      }
    }

    .switcher-box {
      margin-top: 128px;

      &__title {
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 40px;
      }

      .switcher {
        display: none;
      }

      .mobile-switcher {
        display: block;
        .switcher-info-box {
          width: 100%;
        }
        .switcher-info-box-elements-dots-box {
          display: flex;
          justify-content: center;
          width: 100%;
          gap: 8px;
          margin-top: 16px;
          .dot {
            width: 6px;
            height: 6px;
            background: #e1e5f0;
            border-radius: 100%;
          }
          .dot_active {
            background: $primary;
          }
        }
      }
    }

    .examples-box {
      margin: 128px auto;
      &__title {
        font-size: 24px;
        line-height: 32px;
      }
    }

    .examples-box-elements {
      display: none;
    }

    .mobile-examples-box-elements {
      display: flex;
      flex-wrap: wrap;
      .examples-box-elements__el {
        display: none;
      }
      .examples-box-elements__el_active {
        display: block;
        width: 100% !important;
      }
    }
    .mobile-examples-box-elements-dots-box {
      display: flex;
      justify-content: center;
      width: 100%;
      gap: 8px;
      margin-top: 16px;
      .dot {
        width: 6px;
        height: 6px;
        background: #e1e5f0;
        border-radius: 100%;
      }
      .dot_active {
        background: $primary;
      }
    }
  }
  .end-block {
    padding: 89px 0;

    .end-block-info {
      .end-block-info__title.mobile-end-block-info__title {
        width: 100%;
        font-size: 24px;
        line-height: 32px;
        margin-bottom: 64px;
      }

      .end-block-info__button {
        //display: none;
        width: 100%;
        height: 44px;
        font-weight: 600;
        font-size: 16px;
        line-height: 16px;

        button {
          width: 100%;
        }
      }
    }
  }
}
</style>
